import { Button } from '@/components/tiptap-editor/tiptap-ui-primitive/button';
import { Pencil, PencilOff } from 'lucide-react';
import { useEffect } from 'react';

interface ZyEditToolButtonProps {
    isEditing: boolean;
    onSetIsEditing: (isEditing: boolean) => void;
    className?: string;
    disabled?: boolean;
}

export const ZyEditToolButton = ({ isEditing, onSetIsEditing, className, disabled }: ZyEditToolButtonProps) => {
    useEffect(() => {
        if (!isEditing) {
            return;
        }
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onSetIsEditing(false);
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isEditing, onSetIsEditing]);

    return (
        <Button
            onClick={() => onSetIsEditing(!isEditing)}
            className={`cursor-pointer rounded p-1.5 text-gray-600 !bg-transparent transition-colors hover:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 ${className}`}
            disabled={disabled}
            tooltip={disabled ? 'Edit tool not available' : isEditing ? 'Exit editing' : 'Edit tool'}
            shortcutKeys={isEditing ? 'Escape' : ''}
            showTooltip={true}
        >
            {isEditing ? <PencilOff className="h-4 w-4" /> : <Pencil className="h-4 w-4" />}
        </Button>
    );
};
